import React from 'react';
import { motion } from 'framer-motion';
import Button from '../components/ui/Button';

const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 1, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function Blueprint() {
  const CHECKOUT_URL = "https://buy.stripe.com/6oUdR9b7R8e6gCog9tcfK04";
  const BOOKING_URL = "https://link.nordiccrm.ca/widget/bookings/dorman-ernest-baltazar-personal-calendar-qg2bbc8wa";

  return (
    <div className="w-full bg-kin-black">
      <section className="relative min-h-[95vh] flex items-center justify-center px-6 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute top-1/4 left-1/4 w-[60vw] h-[60vh] bg-kin-gold/5 blur-[160px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/4 w-[50vw] h-[50vh] bg-kin-gold/5 blur-[140px] rounded-full"></div>
        </div>
        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <FadeUp> <p className="text-kin-gold tracking-[0.4em] text-xs uppercase font-light mb-10"> The Flagship Framework </p> </FadeUp>
          <FadeUp delay={0.2}> <h1 className="text-4xl md:text-6xl lg:text-8xl font-serif text-balance leading-[1.05] text-kin-ivory mb-12"> How To Build A <span className="italic">Purpose-Driven</span> Life, Brand, And Income. </h1> </FadeUp>
          <FadeUp delay={0.6} className="flex flex-col items-center gap-6">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="px-16 py-6 text-sm"> Get The Blueprint </Button>
            </a>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="text-xs uppercase tracking-[0.3em] text-kin-ivory/40 hover:text-kin-gold transition-colors">
              Questions? Schedule A Discovery Call
            </a>
          </FadeUp>
        </div>
      </section>

      <section className="py-40 md:py-56 px-6 text-center border-t border-kin-ivory/5">
        <div className="max-w-4xl mx-auto">
          <FadeUp> <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif text-kin-ivory leading-tight mb-16"> Build Something That Can <br/> <span className="italic text-kin-gold">Sustain Your Soul.</span> </h2> </FadeUp>
          <FadeUp delay={0.2}>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="px-16 py-6 text-sm"> Access The Blueprint </Button>
            </a>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}